import React from 'react';
interface Column<T> {
  header: string;
  accessor: keyof T | ((item: T) => React.ReactNode);
  className?: string;
}
interface TableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?: (item: T) => void;
  keyExtractor: (item: T) => string | number;
}
export function Table<T>({
  data,
  columns,
  onRowClick,
  keyExtractor
}: TableProps<T>) {
  return <div className="overflow-x-auto rounded-lg border border-gray-200" data-id="element-145">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-146">
        <thead className="bg-gray-50" data-id="element-147">
          <tr data-id="element-148">
            {columns.map((col, idx) => <th key={idx} scope="col" className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${col.className || ''}`} data-id="element-149">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-150">
          {data.length > 0 ? data.map(item => <tr key={keyExtractor(item)} onClick={() => onRowClick && onRowClick(item)} className={onRowClick ? 'cursor-pointer hover:bg-gray-50 transition-colors' : ''} data-id="element-151">
                {columns.map((col, idx) => <td key={idx} className={`px-6 py-4 whitespace-nowrap text-sm text-gray-900 ${col.className || ''}`} data-id="element-152">
                    {typeof col.accessor === 'function' ? col.accessor(item) : item[col.accessor] as React.ReactNode}
                  </td>)}
              </tr>) : <tr data-id="element-153">
              <td colSpan={columns.length} className="px-6 py-8 text-center text-sm text-gray-500" data-id="element-154">
                Tidak ada data tersedia
              </td>
            </tr>}
        </tbody>
      </table>
    </div>;
}